'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _containers = require('containers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (store) {
  return _react2.default.createElement(
    _reactRouter.Route,
    { path: '/', component: _containers.App },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _containers.Home }),
    _react2.default.createElement(_reactRouter.Route, { path: '/funds/:fundId/:investmentVehicleId/:ticker', component: _containers.FundRedirect }),
    _react2.default.createElement(_reactRouter.Route, { path: '/funds/:fundId/:investmentVehicleId', component: _containers.FundRedirect }),
    _react2.default.createElement(_reactRouter.Route, { path: '/fund/:name/:ticker/gun-investments/:fundId/:investmentVehicleId', component: _containers.FundGunInvestments }),
    _react2.default.createElement(_reactRouter.Route, { path: '/funds', component: _containers.List }),
    _react2.default.createElement(_reactRouter.Route, { path: '/compare', component: _containers.Compare }),
    _react2.default.createElement(_reactRouter.Route, { path: '/families', component: _containers.Family }),
    _react2.default.createElement(_reactRouter.Route, { path: '/about', component: _containers.About }),
    _react2.default.createElement(_reactRouter.Route, { path: '/how-it-works', component: _containers.HowItWorks }),
    _react2.default.createElement(_reactRouter.Route, { path: '/action-toolkit', component: _containers.Toolkit }),
    _react2.default.createElement(_reactRouter.Route, { path: '/media', component: _containers.Media }),
    _react2.default.createElement(_reactRouter.Route, { path: '/legal', component: _containers.Legal }),
    _react2.default.createElement(_reactRouter.Route, { path: '/companies', component: _containers.Companies }),
    _react2.default.createElement(_reactRouter.Route, { path: '/index-funds', component: _containers.IndexFunds }),
    _react2.default.createElement(_reactRouter.Route, { path: '/target-date-funds', component: _containers.TargetDateSeries }),
    _react2.default.createElement(_reactRouter.Route, { path: '/target-date-funds/:strategyName', component: _containers.TargetDateSeries }),
    _react2.default.createElement(_reactRouter.Route, { path: '*', component: _containers.NotFound, status: 404 })
  );
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/routes.js
// module id = 1355
// module chunks = 0